import { createRouter } from '@tanstack/react-router';
import { NotFound, routeTree } from './routes/index.js';

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFound,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
